// 3rd Party
import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import { Div, MarketingButton } from 'common/styles/oc-styled-components';

import {
  ProfileSubsectionHeader,
  ProfileSubsectionTitle,
  ProfileSubsectionBody,
  FeatureName,
  FeatureList,
} from '../../profile-styled-components';

// Other
import { PROFILE_COVID_SAFETY_PROCEDURE_NAMES } from '../../constants/constants';

const ProfileCovidSafetyProcedures = ({ procedures }) => {
  const [showAllProcedures, setShowAllProcedures] = useState(false);

  const offeredSafetyProcedures = _.map(procedures, (offered, key) => ({
    name: PROFILE_COVID_SAFETY_PROCEDURE_NAMES[key],
    offered,
    key,
  })).filter(procedure => procedure.offered);

  const orderedOfferedSafetyProcedures = _.sortBy(
    offeredSafetyProcedures,
    'name',
  );

  return (
    <Div margin="0 0 50px 0">
      {orderedOfferedSafetyProcedures.length > 0 
        && (
          <section>
            <ProfileSubsectionHeader>
              <ProfileSubsectionTitle fontSize="24px">
                Safety Precautions
              </ProfileSubsectionTitle>
            </ProfileSubsectionHeader>
            <ProfileSubsectionBody>
              {showAllProcedures
                ? (
                  <FeatureList>
                    {orderedOfferedSafetyProcedures.map(procedure => (
                      <FeatureName key={procedure.key}>
                        {procedure.name}
                      </FeatureName>
                    ))}
                  </FeatureList>
                )
                : (
                  <FeatureList>
                    {orderedOfferedSafetyProcedures.slice(0, 6).map(procedure => (
                      <FeatureName key={procedure.key} margin="0 0 100px 0">
                        {procedure.name}
                      </FeatureName>
                    ))}
                  </FeatureList>
                )
              }
              {orderedOfferedSafetyProcedures.length > 6 
                && (
                  <MarketingButton
                    type="secondary"
                    shape="round"
                    onClick={() => setShowAllProcedures(!showAllProcedures)}
                  >
                    {showAllProcedures ? 'Show Less' : 'View More'} Safety
                    Procedures
                  </MarketingButton>
                )
              }
            </ProfileSubsectionBody>
          </section>
        )
      }
    </Div>
  );
};

ProfileCovidSafetyProcedures.propTypes = {
  procedures: PropTypes.object,
};

export default ProfileCovidSafetyProcedures;
